import styles from "./Footer.module.css";
import linkedIn from "../../../Assests/icons/ic-link (1).svg";
import emailSvg from "../../../Assests/icons/emailSvg.svg";
import phoneSvg from "../../../Assests/icons/phoneSvg.svg";
import mapSvg from "../../../Assests/icons/mapSvg.svg";
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className={styles.footer_section}>
      <div className={styles.footer_container}>
        <div className={styles.inner}>
          {/* <div className={styles.contactDetails}>
            <div className={styles.contactItem}>
              <img src={emailSvg} alt="Email Icon" className={styles.icon} />
              <a
                title="email"
                href="mailto:sales@hyproc-intl.com"
                className={styles.emailIcon}
              >
                sales@hyproc-intl.com
              </a>
            </div>
            <div className={styles.contactItem}>
              <img src={phoneSvg} alt="Phone Icon" className={styles.icon} />
              <span>+44 (0) 1895230686</span>
            </div>
            <div className={styles.contactItem}>
              <img src={mapSvg} alt="Map Icon" className={styles.icon} />
              <span>
                Hyproc International Limited<br />
                Eagle Court 9 Vine Road<br />
                Uxbridge UB8 1QE
              </span>
            </div>
          </div> */}
          <nav className={styles.nav}>
            <NavLink to="/" className={styles.link}>
              HOME
            </NavLink>
            <NavLink to="/about" className={styles.link}>
              ABOUT US
            </NavLink>
            <NavLink to="/global" className={styles.link}>
              GLOBAL TEAM
            </NavLink>
            <NavLink to="/product" className={styles.link}>
              PRODUCT & SUPPLY
            </NavLink>
            <NavLink to="/procurement" className={styles.link}>
              PROCUREMENT & SHIPPING
            </NavLink>
            <NavLink to="/contact" className={styles.link}>
              CONTACT US
            </NavLink>
          </nav>
          <div className={styles.right}>
            <span className={styles.copy}>© 2025 Hyproc International</span>
          </div>
          <div className={styles.linkedIn}>
            <img src={linkedIn} alt="" />
          </div>
        </div>
      </div>
    </footer>
  );
}
